import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

export default new Vuetify({

    theme: {
        themes: {
          light: {
            primary: '#204281',
            secondary: '#0096D7',
            accent: '#FDBB30',
            error: '#FDBB30',
          },
        },
      }
      
});
